import React from 'react';
import { Pagination as RBPagination } from 'react-bootstrap';
const Pagination = _ref => {
  let {
    currentPage,
    totalPages,
    handlePageChange
  } = _ref;
  const pagesToShow = 10;

  // Calculate the range of page numbers to display
  const startPage = Math.max(1, currentPage - pagesToShow);
  const endPage = Math.min(totalPages, currentPage + pagesToShow);
  return /*#__PURE__*/React.createElement(RBPagination, {
    className: "justify-content-center"
  }, /*#__PURE__*/React.createElement(RBPagination.First, {
    onClick: () => handlePageChange(1),
    disabled: currentPage === 1
  }), /*#__PURE__*/React.createElement(RBPagination.Prev, {
    onClick: () => handlePageChange(currentPage - 1),
    disabled: currentPage === 1
  }), startPage > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RBPagination.Item, {
    onClick: () => handlePageChange(1)
  }, "1"), startPage > 2 && /*#__PURE__*/React.createElement(RBPagination.Ellipsis, null)), Array.from({
    length: endPage - startPage + 1
  }, (_, i) => /*#__PURE__*/React.createElement(RBPagination.Item, {
    key: startPage + i,
    active: startPage + i === currentPage,
    onClick: () => handlePageChange(startPage + i)
  }, startPage + i)), endPage < totalPages && /*#__PURE__*/React.createElement(React.Fragment, null, endPage < totalPages - 1 && /*#__PURE__*/React.createElement(RBPagination.Ellipsis, null), /*#__PURE__*/React.createElement(RBPagination.Item, {
    onClick: () => handlePageChange(totalPages)
  }, totalPages)), /*#__PURE__*/React.createElement(RBPagination.Next, {
    onClick: () => handlePageChange(currentPage + 1),
    disabled: currentPage === totalPages
  }), /*#__PURE__*/React.createElement(RBPagination.Last, {
    onClick: () => handlePageChange(totalPages),
    disabled: currentPage === totalPages
  }));
};
export default Pagination;